export default `:host {
  --ids-module-nav-user-margin-inline: 10px;
  --ids-module-nav-user-padding-block: 13px;
  box-sizing: border-box;
}

::slotted(ids-hyperlink) {
  color: var(--ids-module-nav-text-color);
}

::slotted(ids-hyperlink[hidden]) {
  display: none;
}

::slotted(ids-text) {
  color: inherit;
}

::slotted(span) {
  color: inherit;
}

.ids-module-nav-user {
  align-items: center;
  color: var(--ids-module-nav-item-text-color);
  display: flex;
  flex-direction: row;
  padding-block: var(--ids-module-nav-user-padding-block);
}
.ids-module-nav-user:not([class*=display-mode-]) .ids-module-nav-user-avatar {
  display: none;
}
.ids-module-nav-user:not([class*=display-mode-]) .ids-module-nav-user-details {
  display: none;
}
.ids-module-nav-user.display-mode-collapsed {
  justify-content: center;
  margin-inline: var(--ids-module-nav-user-margin-inline);
}
.ids-module-nav-user.display-mode-collapsed .ids-module-nav-user-details {
  display: none;
}
.ids-module-nav-user.display-mode-expanded {
  margin-inline: var(--ids-module-nav-user-margin-inline);
}
.ids-module-nav-user.display-mode-expanded .ids-module-nav-user-details {
  margin-inline-start: var(--ids-module-nav-item-margin-inline);
}

.ids-module-nav-user-avatar {
  text-align: center;
}

.ids-module-nav-user-details {
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
